import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CodeValue from '~/components/patterns/values/CodeValue';
import Ellipsis from '~/components/patterns/values/Ellipsis';
import SmallTable from '~/components/atoms/issues/components/detailsPlaceholders/SmallTable';



const messages = defineMessages({
	status: {
		id: 'ui.contentOverview.tableHeading.status_code',
	},
	url: {
		id: 'ui.contentData.url',
	},
});



type Props = {
	issue: {
		context: {
			sample_urls: ReadonlyArray<{
				redirect_target: string | null,
				status_code: number,
				url: string,
			}>,
		},
	},
	tableWidth: number,
};

const SampleUrlsWithStatusCodeTable: React.FC<Props> = (props) => {
	const {
		issue,
		tableWidth,
	} = props;

	const firstColumnWidth = Math.ceil(tableWidth * 0.5);

	return (
		<SmallTable
			columns={[
				{
					hasData: () => true,
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									{row.url}
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.url} />,
					},
					width: firstColumnWidth,
				},
				{
					hasData: () => true,
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									<CodeValue>
										{row.status_code}

										{row.redirect_target !== null && (
											<span> ({row.redirect_target})</span>
										)}
									</CodeValue>
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.status} />,
					},
					width: tableWidth - firstColumnWidth - 2,
				},
			]}
			rows={issue.context.sample_urls}
			tableWidth={tableWidth}
		/>
	);
};



export default React.memo(SampleUrlsWithStatusCodeTable);
